import { render, staticRenderFns } from "./SeatPrice.vue?vue&type=template&id=07805492&"
import script from "./SeatPrice.vue?vue&type=script&lang=js&"
export * from "./SeatPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports